export default {
    MOBILE_WIDTH: 500,
    BREAK_POINT_1:700,
    DRAWER_WIDTH:315
}